/*
 * @Author: ken yang
 * @Date: 2022-08-30 11:14:14
 * @LastEditTime: 2022-09-13 15:28:49
 * @LastEditors: ken yang
 * @Description:
 * @FilePath: /uexch_pc/src/store/index.js
 */
import { createPinia } from 'pinia'
import useUserStore from '@/store/user.js'
import useMapStore from '@/store/map.js'
import useConfigStore from '@/store/config.js'

const pinia = createPinia()

const init = (context) => {
  context.pinia // 使用 `createPinia()` 创建的 pinia
  context.app // 使用 `createApp()` 创建的当前应用程序（仅限 Vue 3）
  context.store // 插件正在扩充的 store
  context.options // 定义存储的选项对象传递给`defineStore()`
  console.log(1112)
  if (context.options.init) {
    context.options.init.call(context.store)
  }
}

pinia.use(init)

export default pinia
export { useUserStore, useConfigStore, useMapStore }
